import { render, staticRenderFns } from "./ClientLostReasonModal.vue?vue&type=template&id=2055fa5a&"
import script from "./ClientLostReasonModal.vue?vue&type=script&lang=js&"
export * from "./ClientLostReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports